import Title from 'components/summary/Title/component';

export default Title;
